import React from 'react'

export const Footer = () => {
  
    let footerStyle = {
        position: "relative",
        top: "70vh",
        width: "100%"
        
        
    }
    return (
    <footer className="bg-dark text-light py-3" style={footerStyle}>
      <p className='text-center' color='light'>
      Disclaimer:
        Content Owned and Maintained by @UVDevloper, 
          All the copyright are reserverd according to T&C.  
      </p>
      <p className='text-center'>Designed, Developed and hosted by Yuvraj Singh, 3rd year Student.</p>
    </footer>
    
  )
}
